import { inspect } from 'util'
import type { AxiosError } from '@glovo/fetcher'
// eslint-disable-next-line no-restricted-imports
import { isAxiosError } from '@glovo/rum'
import { logger } from './index.node'

function stringifyLogMessage(value: unknown[]): string {
  return value.every((item) => typeof item === 'string') ? value.join(' ') : inspect(value)
}

function findErrorInstance(value: unknown[]): Error | null {
  const errors = value.filter((item): item is Error => item instanceof Error)
  const error = errors[0]

  if (!error) {
    return null
  }

  if (isAxiosError(error)) {
    const axiosError = error as AxiosError
    //@ts-expect-error we need to keep path
    error['path'] = axiosError.request?.path
    //@ts-expect-error we need to keep response data
    error['data'] = axiosError.response?.data

    delete (error as AxiosError).request
    delete (error as AxiosError).response
  }

  return error
}

function getLogEntity(value: unknown[]): string | Error {
  const error = findErrorInstance(value)

  return error !== null ? error : stringifyLogMessage(value)
}

export function decorateConsole() {
  // NOTE: re-assigning whole object so references to the old one remain intact
  // eslint-disable-next-line @glovo/custom-rules/no-console
  global.console = {
    ...global.console,
    log(...args: Parameters<typeof console.log>) {
      logger.info('SERVER_LOG', getLogEntity(args))
    },
    info(...args: Parameters<typeof console.info>) {
      logger.info('SERVER_INFO', getLogEntity(args))
    },
    error(...args: Parameters<typeof console.error>) {
      logger.error('SERVER_ERROR', getLogEntity(args))
    },
    warn(...args: Parameters<typeof console.warn>) {
      logger.warn('SERVER_WARN', getLogEntity(args))
    },
    debug(...args: Parameters<typeof console.debug>) {
      logger.debug('SERVER_DEBUG', getLogEntity(args))
    },
  }
}
